/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.app-modal-title[_ngcontent-%COMP%] {\n	height: 50px;\n}\n.app-modal-content[_ngcontent-%COMP%] {\n	height: calc(100% - 85px);\n}\n.app-modal-footer[_ngcontent-%COMP%] {\n	height: 30px;\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL29wdC9qZW5raW5zL3dvcmtzcGFjZS9naXNlbGFfcG9ydGFsL3NyYy9hcHAvY29tcG9uZW50cy9wb3J0YWwvYTNpLXNldHRpbmcvYTNpLW5hZy9uYWctYWxpYXMtbW9kYWwvbmFnLWFsaWFzLW1vZGFsLmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vb3B0L2plbmtpbnMvd29ya3NwYWNlL2dpc2VsYV9wb3J0YWwvc3JjL2FwcC9jb21wb25lbnRzL3BvcnRhbC9hM2ktc2V0dGluZy9hM2ktbmFnL25hZy1hbGlhcy1tb2RhbC9uYWctYWxpYXMtbW9kYWwuY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/portal/a3i-setting/a3i-nag/nag-alias-modal/nag-alias-modal.component.css.shim.ngstyle.ts